import {
    current,
    calls,
    nextCalls,
    gameToGo,
    fireBallStatus,
} from '../../stores/backend';
import { BackendSocket } from '../../hooks/use-socket';
import { BingoCallMessage } from '../../types/bingo-events/in/backend/call-message';
import { compatibleCalls, isValidPart, withCurrentSession } from './session';
import { suspendApp } from '../../lib/suspension';

export const onCallMessage = (socket: BackendSocket) => {
    const callback = (data: BingoCallMessage) =>
        withCurrentSession('bingo:callMessage', data?.gameSessionId, () => {
            if (
                !isValidPart(data.part) ||
                !Array.isArray(data.callNumbers) ||
                data.callNumbers.some(
                    (number) =>
                        !Number.isInteger(number) ||
                        number < 1 ||
                        number > parseInt(current.game_type.value, 10)
                ) ||
                new Set(data.callNumbers).size !== data.callNumbers.length ||
                !compatibleCalls(calls.value, data.callNumbers)
            ) {
                suspendApp({
                    event: 'bingo:callMessage:invalid-state',
                    expectedSessionId: current.game_sid.value,
                    receivedSessionId: data.gameSessionId,
                });
                return;
            }
            if (
                data.callNumbers.length < calls.value.length ||
                data.part - 1 < current.current_part.value
            )
                return;
            const fireBall = current.fireball.value;

            if (fireBall) {
                if (
                    fireBallStatus.value === 'pending' &&
                    data.callNumber !== fireBall
                ) {
                    fireBallStatus.set('snuffed');
                } else if (data.callNumber === fireBall) {
                    fireBallStatus.set('pending');
                }
            }

            calls.set(data.callNumbers);
            nextCalls.set(data.nextCallballs);
            gameToGo.set(data.gameToGo || {});
            current.merge({
                current_part: data.part - 1,
            });
        });

    socket.on('bingo:callMessage', callback);

    return () => {
        socket.off('bingo:callMessage', callback);
    };
};
